module.exports = __webpack_public_path__ + "img/feed.f6fe329f.png";